import { render } from "./File.vue?vue&type=template&id=3f946524"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"
script.render = render

export default script